<div class="container">
  <div class="text-center">
    <h5 class="display-5 mt-3 mb-4">Modify Subjects</h5>
  </div>
</div>

<div class="container">
  <button type="button" class="btn btn-success addNewSubject-btn" data-toggle="modal" data-target="#addNewSubjectModal">
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-plus pb-1" viewBox="0 0 16 16">
      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
    </svg>
    Add New Subject
  </button>
  <hr>
</div>

<!-- Add New Subject Modal -->
<div class="modal fade" id="addNewSubjectModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Add New Subject</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <label>Subject Name:</label>
        <div class="input-group input-group-lg mb-3">
          <input type="text" class="form-control" [(ngModel)]="subjectHeading">
        </div>

        <label>Subtopics:</label>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="subjectSubheadings[0]">
        </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="subjectSubheadings[1]">
        </div>
        <div class="input-group mb-4">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="subjectSubheadings[2]">
        </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="subjectSubheadings[3]">
        </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="subjectSubheadings[4]">
        </div>
        <div class="input-group mb-4">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="subjectSubheadings[5]">
        </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="subjectSubheadings[6]">
        </div>
        <div class="input-group mb-4">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="subjectSubheadings[7]">
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="onAdd()">Add</button>
      </div>
    </div>
  </div>
</div>

<div class="my-5" *ngIf="isSubjectsLoading == true" style="width: 100%; display: flex; align-items: center; justify-content: center;">
  <div class="loader"></div>
  <div>
    Loading Subjects...
  </div>
</div>

<div class="container" *ngIf="isSubjectsLoading == false">
  <h4 class="pb-3">My Subject List</h4>
  <div class="row">
    <div class="col-md-4 pb-5" *ngFor="let subject of subjectsList">
      <div class="card text-center">
        <div class="card-header bg-dark text-white">
          <h3 class="mt-1">{{ subject.title }}</h3>
        </div>
        <div class="card-body" style="color: black;">
          <ul class="list-group">
            <li class="list-group-item" *ngIf="subject.details[0]">
              <i class="fas fa-check"></i> {{ subject.details[0] }}
            </li>
            <li class="list-group-item" *ngIf="subject.details[1]">
              <i class="fas fa-check"></i> {{ subject.details[1] }}
            </li>
            <li class="list-group-item" *ngIf="subject.details[2]">
              <i class="fas fa-check"></i> {{ subject.details[2] }}
            </li>
            <li class="list-group-item" *ngIf="subject.details[3]">
              <i class="fas fa-check"></i> {{ subject.details[3] }}
            </li>
            <li class="list-group-item" *ngIf="subject.details[4]">
              <i class="fas fa-check"></i> {{ subject.details[4] }}
            </li>
            <li class="list-group-item" *ngIf="subject.details[5]">
              <i class="fas fa-check"></i> {{ subject.details[5] }}
            </li>
            <li class="list-group-item" *ngIf="subject.details[6]">
              <i class="fas fa-check"></i> {{ subject.details[6] }}
            </li>
            <li class="list-group-item" *ngIf="subject.details[7]">
              <i class="fas fa-check"></i> {{ subject.details[7] }}
            </li>
          </ul>
          <div class="row text-center">
            <div class="col">
              <button
                class="btn btn-danger btn-block mt-3"
                data-toggle="modal"
                data-target="#deleteSubjectModal"
                (click)="onDelete(subject._id)">
                  Delete
              </button>
            </div>
            <div class="col">
              <button
                class="btn btn-info btn-block mt-3"
                data-toggle="modal"
                data-target="#updateSubjectModal"
                (click)="onUpdate(subject)">
                  Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Update Subject Modal -->
<div class="modal fade" id="updateSubjectModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Update Subject</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <label>Subject Name:</label>
        <div class="input-group input-group-lg mb-3">
          <input type="text" class="form-control" [(ngModel)]="selectedSubjectTitle">
        </div>

        <label>Subtopics:</label>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="selectedSubjectSubtopic1">
        </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="selectedSubjectSubtopic2">
        </div>
        <div class="input-group mb-4">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="selectedSubjectSubtopic3">
        </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="selectedSubjectSubtopic4">
        </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="selectedSubjectSubtopic5">
        </div>
        <div class="input-group mb-4">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="selectedSubjectSubtopic6">
        </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="selectedSubjectSubtopic7">
        </div>
        <div class="input-group mb-4">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">✓</span>
          </div>
          <input type="text" class="form-control" [(ngModel)]="selectedSubjectSubtopic8">
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="onUpdateConfirm()">Update</button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Subject Modal -->
<div class="modal fade" id="deleteSubjectModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Are you sure?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Do you really want to delete this subject?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-outline-dark" data-dismiss="modal" (click)="onDeleteConfirm()">Confirm</button>
        <button type="button" class="btn btn-sm btn-outline-danger" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>
